/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type KarteUserDetailedProfileChildFragment = { age: number, gender: Types.Gender };

export type KarteUserDetailedProfileDiagnosisFragment = { annualIncome: number, saving: number, monthlyInsurance: number, investment: number, partner: { birthYear: number, annualIncome: number } | null, children: Array<{ age: number, gender: Types.Gender }> };

export const KarteUserDetailedProfileChildFragmentDoc = gql`
    fragment KarteUserDetailedProfileChild on DiagnosisChild {
  age
  gender
}
    `;
export const KarteUserDetailedProfileDiagnosisFragmentDoc = gql`
    fragment KarteUserDetailedProfileDiagnosis on Diagnosis {
  partner {
    birthYear
    annualIncome
  }
  annualIncome
  saving
  monthlyInsurance
  investment
  children {
    ...KarteUserDetailedProfileChild
  }
}
    ${KarteUserDetailedProfileChildFragmentDoc}`;